import { TICKET_CONSTANTS } from '~/shared/constants';
import { TicketFilters } from '../types';

const { DATE } = TICKET_CONSTANTS;

export function formatDateForApi(dateString: string): string | undefined {
  if (!dateString || dateString.length !== DATE.FORMAT_LENGTH) {
    return undefined;
  }

  try {
    const [day, month, year] = dateString.split('/');
    const date = new Date(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10)
    );

    if (Number.isNaN(date.getTime())) {
      return undefined;
    }

    return date.toISOString().split('T')[0];
  } catch {
    return undefined;
  }
}

export function filtersToApiParams(filters: {
  search?: string;
  category?: string[];
  zone?: string[];
  status?: string[];
  businessUnit?: string[];
  createdDateFrom?: string;
  createdDateTo?: string;
}): TicketFilters {
  const apiFilters: TicketFilters = {};

  if (filters.search?.trim()) {
    apiFilters.search = filters.search.trim();
  }

  if (filters.category && filters.category.length > 0) {
    apiFilters.category = filters.category.join(',');
  }

  if (filters.zone && filters.zone.length > 0) {
    apiFilters.zone = filters.zone.join(',');
  }

  if (filters.status && filters.status.length > 0) {
    apiFilters.status = filters.status.join(',');
  }

  if (filters.businessUnit && filters.businessUnit.length > 0) {
    apiFilters.businessUnit = filters.businessUnit.join(',');
  }

  if (filters.createdDateFrom) {
    apiFilters.createdDateFrom = formatDateForApi(filters.createdDateFrom);
  }

  if (filters.createdDateTo) {
    apiFilters.createdDateTo = formatDateForApi(filters.createdDateTo);
  }

  return apiFilters;
}

export function hasValidFilters(filters: TicketFilters): boolean {
  return Object.values(filters).some(
    value => value !== undefined && value !== null && value !== ''
  );
}
